import { useEffect, useState } from "react";
import MessageSubHeading from "./MessageSubHeading";
import "../../Styles/adminTable.css";
import Defaultloadinggif from "../../layout/Others/Defaultloadinggif";


const AdminTable = ({ multiSelect, viewType, data, columns, page, options, selectRow, onRowSelect, onSort, tableBg, onSelectAll, pagination, handlePageChange, handleSizePerPageChange, limit, loading, showcustomStyle, colStyle, rowStyle }) => {

    const [visiblePages, setVisiblePages] = useState([]);
    const [customLimit, setCustomLimit] = useState('');

    const defaultSizePerPageList = [
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
        { text: '150', value: 150 },
        { text: '200', value: 200 },
        { text: 'All', value: pagination?.totalItems || 9999 },
    ];

    const handleCustomLimitApply = () => {
        const val = parseInt(customLimit, 10);
        if (val > 0) {
            handleSizePerPageChange({ target: { value: val } });
            setCustomLimit('');
        }
    };

    const handleRowSelect = (rowId) => {
        onRowSelect(rowId);
    };

    const handleSort = (field) => {
        if (onSort) {
            onSort(field);
        }
    };

    const handleSelectAll = () => {
        onSelectAll();
    };

    const isAllSelected = data?.every((row) => selectRow?.selected.includes(row?.id));
    const startRow = (page - 1) * pagination?.itemsPerPage + 1;
    const endRow = Math.min(page * pagination?.itemsPerPage, pagination?.totalItems);
    const updateVisiblePages = (currentPage) => {
        if (!pagination?.totalPages || pagination?.totalPages <= 0) return;
        const totalPages = pagination?.totalPages;
        const paginationSize = options?.paginationSize || 3;
        let startPage = Math.max(1, currentPage - Math.floor(paginationSize / 2));
        let endPage = Math.min(totalPages, startPage + paginationSize - 1);
        startPage = Math.max(1, endPage - paginationSize + 1);
        setVisiblePages(Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index));
    };
    const handlePageChangeInternal = (pageNum) => {
        handlePageChange(pageNum);
        updateVisiblePages(pageNum);
    };

    useEffect(() => {
        updateVisiblePages(page);
    }, [page, pagination?.totalPages]);

    const formatValue = (value) => {
        return (value !== undefined && value !== null && value !== '') ? value : '-';
    };

    return (
        <div>
            {viewType === "list" && (
                columns?.length === 0 ? (
                    <div style={{ overflowX: 'auto' }}>
                        <table className={`${tableBg} w-100`}>
                            <thead>
                                <tr className="theme-border-secondary-color">
                                    {multiSelect && (
                                        <th style={{ width: "6%" }} className="p-3">
                                            <input
                                                type="checkbox"
                                                checked={isAllSelected}
                                                onChange={handleSelectAll}
                                                className="table-checkbox"
                                                id="selectAllItems"
                                            />
                                        </th>
                                    )}
                                    {columns.map((col) => (
                                        <th
                                            key={col.dataField}
                                            className={`table-column-heading ${col.colStyle || ""}`}
                                            style={{ width: col.width || "150px" }}
                                        >
                                            {col.text}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr className="theme-border-secondary-color">
                                        <td className="p-3" colSpan={columns.length + 1}>
                                            <Defaultloadinggif />
                                        </td>
                                    </tr>
                                ) : data?.length > 0 ? (
                                    data.map((row, rowIndex) => (
                                        <tr key={row.id} className="theme-border-secondary-color">
                                            {selectRow && multiSelect && (
                                                <td className="p-3" style={{ width: "6%" }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectRow.selected.includes(row.id)}
                                                        onChange={() => handleRowSelect(row.id)}
                                                        className="table-checkbox"
                                                        id={`selectItem${row.id}`}
                                                    />
                                                </td>
                                            )}
                                            {columns.map((col) => (
                                                <td
                                                    key={col.dataField}
                                                    className={`py-2 ${showcustomStyle ? "px-1" : ""} ${col.rowStyle || ""} ${col.colStyle || ""} ${(row[col.dataField] === undefined || row[col.dataField] === null || row[col.dataField] === "") &&
                                                        !col.formatter
                                                        ? "text-center"
                                                        : ""
                                                        }`}
                                                    style={{ width: col?.width }}
                                                >
                                                    {typeof col.formatter === "function"
                                                        ? col.isDummyField
                                                            ? col.formatter(null, row, rowIndex)
                                                            : col.formatter(row[col.dataField], row, rowIndex)
                                                        : formatValue(row[col.dataField])}
                                                </td>
                                            ))}
                                        </tr>
                                    ))
                                ) : (
                                    <tr className="theme-border-secondary-color">
                                        <td className="p-3" colSpan={columns.length + 1}>
                                            <p className="text-center">No data found !</p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div style={{ overflowX: 'auto', paddingBottom: '90px' }}>
                        <table className={`${tableBg} w-100`}>
                            <thead>
                                <tr className="theme-border-secondary-color">
                                    {multiSelect && (
                                        <th style={{ width: "6%" }} className="p-3">
                                            <input
                                                type="checkbox"
                                                checked={isAllSelected}
                                                onChange={handleSelectAll}
                                                className="table-checkbox"
                                                id="selectAllItems"
                                            />
                                        </th>
                                    )}
                                    {columns.map((col) => (
                                        <th
                                            key={col.dataField}
                                            className={`table-column-heading ${col.colStyle || ""}`}
                                            style={{ width: col.width || "150px" }}
                                        >
                                            {col.text}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr className="theme-border-secondary-color">
                                        <td className="p-3" colSpan={columns.length + 1}>
                                            <Defaultloadinggif />
                                        </td>
                                    </tr>
                                ) : data?.length > 0 ? (
                                    data.map((row, rowIndex) => (
                                        <tr key={row.id} className="theme-border-secondary-color">
                                            {selectRow && multiSelect && (
                                                <td className="p-3" style={{ width: "6%" }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectRow.selected.includes(row.id)}
                                                        onChange={() => handleRowSelect(row.id)}
                                                        className="table-checkbox"
                                                        id={`selectItem${row.id}`}
                                                    />
                                                </td>
                                            )}
                                            {columns.map((col) => (
                                                <td
                                                    key={col.dataField}
                                                    className={`py-2 ${showcustomStyle ? "px-1" : ""} ${col.rowStyle || ""} ${col.colStyle || ""} ${(row[col.dataField] === undefined || row[col.dataField] === null || row[col.dataField] === "") &&
                                                        !col.formatter
                                                        ? "text-center"
                                                        : ""
                                                        }`}
                                                    style={{ width: col?.width }}
                                                >
                                                    {typeof col.formatter === "function"
                                                        ? col.isDummyField
                                                            ? col.formatter(null, row, rowIndex)
                                                            : col.formatter(row[col.dataField], row, rowIndex)
                                                        : formatValue(row[col.dataField])}
                                                </td>
                                            ))}
                                        </tr>
                                    ))
                                ) : (
                                    <tr className="theme-border-secondary-color">
                                        <td className="p-3" colSpan={columns.length + 1}>
                                            <p className="text-center">No data found !</p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )
            )}

            {viewType === "grid" && (
                <div className="d-flex align-items-start flex-wrap">
                    {loading ? (
                        <p>Loading..</p>
                    ) : data?.length > 0 ? (
                        data.map((row) => (
                            <div className="col-12 col-sm-6 col-md-4 col-xl-3 p-3" key={row?.id}>
                                <div className="overflow-hidden position-relative">
                                    <img
                                        src={row.image}
                                        className="w-100 table-column-grid-image overflow-hidden mb-2 rounded-3"
                                    />
                                    {selectRow && (
                                        <input
                                            type="checkbox"
                                            checked={selectRow.selected.includes(row.id)}
                                            onChange={() => handleRowSelect(row.id)}
                                            className="table-checkbox-list position-absolute"
                                        />
                                    )}
                                    <div className="d-flex flex-wrap justify-content-between">
                                        {columns.map((col) =>
                                            col.formatter ? (
                                                <div
                                                    key={col.dataField}
                                                    className={`${col.text === "Action" || col.text === "Status"
                                                        ? "list-view-action align-self-end w-auto col-6"
                                                        : "col-12"
                                                        } mb-3`}
                                                >
                                                    {col.formatter(row[col.dataField], row)}
                                                </div>
                                            ) : (
                                                <div
                                                    key={col.dataField}
                                                    className="col-6 d-flex align-items-center gap-2 mb-3"
                                                >
                                                    <span>{col.text}:</span>
                                                    <span>{row[col.dataField]}</span>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-center">No data found !</p>
                    )}
                </div>
            )}

            <div className="d-flex align-items-center flex-wrap justify-content-between mt-3">
                <div>
                    <div className="d-flex align-items-center gap-2">
                        <select
                            id="pageLimitChanger"
                            value={limit}
                            onChange={handleSizePerPageChange}
                            className="rounded-3 theme-border-color border-solid-width border-solid show-all"
                        >
                            {(options?.sizePerPageList ?? defaultSizePerPageList).map((option) => (
                                <option key={option.value} value={option.value} id={option?.id}>
                                    {option.text}
                                </option>
                            ))}
                        </select>
                        <input
                            type="number"
                            min="1"
                            value={customLimit}
                            onChange={(e) => setCustomLimit(e.target.value)}
                            onBlur={handleCustomLimitApply}
                            onKeyDown={(e) => e.key === 'Enter' && handleCustomLimitApply()}
                            placeholder="Custom"
                            className="rounded-3 theme-border-color border-solid-width border-solid px-2"
                            style={{ width: '80px', height: '34px', fontSize: '0.85rem' }}
                        />
                        <MessageSubHeading
                            text={`Showing rows ${startRow} to ${endRow} of ${pagination?.totalItems}`}
                            noMargin
                        />
                    </div>
                </div>

                <div className="d-flex align-items-center rounded-3 theme-border-color border-solid-width border-solid">
                    <button
                        className="bg-transparent table-page-count theme-text-color theme-border-color border-solid table-right-border"
                        onClick={() => handlePageChangeInternal(1)}
                        id="startButton"
                        disabled={page === 1}
                    >
                        <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth="0"
                            viewBox="0 0 24 24"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path fill="none" d="M0 0h24v24H0z"></path>
                            <path d="M17.59 18L19 16.59 14.42 12 19 7.41 17.59 6l-6 6z"></path>
                            <path d="M11 18l1.41-1.41L7.83 12l4.58-4.59L11 6l-6 6z"></path>
                        </svg>
                    </button>
                    <button
                        disabled={page === 1}
                        id="prevButton"
                        onClick={() => handlePageChangeInternal(page - 1)}
                        className="fast-length bg-transparent theme-border-color border-solid table-right-border theme-text-color"
                    >
                        Prev
                    </button>

                    {visiblePages?.map((pageNum) => (
                        <button
                            key={pageNum}
                            id={`pageNumber${pageNum}`}
                            onClick={() => handlePageChangeInternal(pageNum)}
                            className={`${page === pageNum ? "theme-bg-color-secondary" : "bg-transparent"
                                } theme-text-color theme-border-color border-solid table-right-border table-page-count`}
                        >
                            {pageNum}
                        </button>
                    ))}

                    <button
                        disabled={page === pagination?.totalPages}
                        id="nextButton"
                        onClick={() => handlePageChangeInternal(page + 1)}
                        className="fast-length theme-text-color bg-transparent theme-border-color border-solid table-right-border"
                    >
                        Next
                    </button>

                    <button
                        id="endButton"
                        className="bg-transparent table-page-count theme-text-color theme-border-color border-solid table-right-border"
                        onClick={() => handlePageChangeInternal(pagination?.totalPages)}
                        disabled={page === pagination?.totalPages}
                    >
                        <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth="0"
                            viewBox="0 0 24 24"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path fill="none" d="M0 0h24v24H0z"></path>
                            <path d="M6.41 6L5 7.41 9.58 12 5 16.59 6.41 18l6-6z"></path>
                            <path d="M13 6l-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z"></path>
                        </svg>
                    </button>
                </div>
            </div>
        </div>

    );
};

export default AdminTable;
